<template>
    <div class="activity">
        <activity-header>文旅活动</activity-header>
        <div class="container">
            <!-- 活动展示 -->
            <section class="public">
                <div class="box">
                    <span class="title">文旅活动</span>
                    <span class="line"></span>
                    <router-link 
                        tag="span" 
                        class="more"
                        :to="{name: 'Policy',query: {id: '07e2377534064779936d4e0e61a54637',title: '文旅活动'}}"
                    >
                        更多
                    </router-link>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <ul class="doingList">
                    <router-link 
                        tag="li"
                        class="lis" 
                        v-for="item in activityList" 
                        :key="item.id"
                        :to="{name: 'Detail',query: {id: item.id,mode: 'ARTICLE'}}"
                    >
                        <div class="iconBox">
                            <img :src="item.image" alt="">
                        </div>
                        <div class="rt">
                            <p class="doingTitle">
                                {{item.title}}
                            </p>
                            <p class="times">{{ item.createDate.split(' ')[0] }}</p>
                        </div>
                    </router-link>
                </ul>
            </section>
            <!-- 太阳码 -->
            <section class="sun">
                <div class="sunCode">
                    <img src="../../assets/images/sun_code.png" alt="">
                </div>
                <div class="sunRt">
                    <h1 class="title">活动报名太阳码</h1>
                    <p class="words">
                        长按太阳码保存至手机用微信打开识别
                    </p>
                </div>
            </section>
            <!-- 站位图 -->
            <section class="adPic">
                <div class="box">
                    <img src="../../assets/images/five_g.png" alt="">
                    <img src="../../assets/images/activity_banner.png" alt="">
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import activityHeader from '../../components/Header';
export default {
    name: 'activity',
    components: {
        activityHeader
    },
    data() {
        return {
            activityList: []
        }
    },
    mounted() {
        this.getActivityList()
    },
    methods: {
        getActivityList(pageNo=1,pageSize=10) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/listByCategoryId',
                method: 'GET',
                params: {
                    categoryId: '07e2377534064779936d4e0e61a54637',
                    pageNo,
                    pageSize,
                    contentType: 'ARTICLE'
                }
            }).then(res => {
                if(res.data.code == 0){
                    this.activityList = res.data.page.list
                    console.log(this.activityList);
                }
            }).catch(err => {
                console.log(err.response);
            })
        }
    },
}
</script>

<style scoped>
.activity{
    background: #F2F3F7;
}
.container{
    height: calc(100vh - 1rem);
    overflow: auto;
}
/* 活动展示 */
.public{
    margin-top: .2rem;
    padding: 0 .3rem;
    background: #fff;
}
.public .box{
    position: relative;
    height: .88rem;
    display: flex;
}
.public .box .title{
    font-weight: bold;
    font-size: .28rem;
    color: #D60000;
    margin-top: .3rem;
}
.public .box .line{
    width: 5.6rem;
    height: 0.02rem;
    background: #D60000;
    margin-top: .56rem;
    margin-left: auto;
}
.public .box .more{
    position: absolute;
    right: .14rem;
    color: #666;
    top: 50%;
    transform: translateY(-70%);
    padding: .1rem;
}
.public .box .bd{
    position: absolute;
    right: 0;
    top: .44rem;
}
.public .doingList {
    overflow: hidden;
}
.public .doingList .lis{
    display: flex;
    margin-bottom: .3rem;
}
.public .doingList .lis .iconBox{
    width: 1.8rem;
    height: 1.2rem;
    margin-right: .2rem;
    display: flex;
    align-items: center;
    overflow: hidden;
}
.public .doingList .lis .iconBox img{
    width: 100%;
    max-height: 100%
}
.public .doingList .lis .rt{
    width: 4.8rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.public .doingList .lis .rt .doingTitle{
    line-height: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.public .doingList .lis .rt .times{
    color: #999;
}
/* 太阳码 */
.sun{
    width: 100%;
    height: 2.2rem;
    display: flex;
    background: #fff;
    align-items: center;
    box-sizing: border-box;
    padding: 0 1rem;
    justify-content: space-between;
    margin-top: .18rem;
}
.sunCode{
    border: .02rem dashed #aaa;
    width: 1.8rem;
    height: 1.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.sunRt{
    width: 3rem;
    display: flex;
    height: 1.8rem;
    flex-direction: column;
    justify-content: space-around;
}
.sunRt .title{
    font-weight: bold;
    font-size: .28rem;
}
.sunRt .words{
    line-height: 1.5;
}
/* 站位图 */
.adPic{
    height: 2.5rem;
    background: #fff;
    margin-top: .2rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
.adPic .box{
    width: 6.92rem;
    display: flex;
    justify-content: space-between;
}
</style>